import { __assign } from "tslib";
export var fillWithEmptyKeys = function (keys, results, emptyValue) {
    if (emptyValue === void 0) { emptyValue = ''; }
    var emptyKeysObject = {};
    keys.forEach(function (key) {
        var _a;
        emptyKeysObject = __assign(__assign({}, emptyKeysObject), (_a = {}, _a[key] = emptyValue, _a));
    });
    return results.map(function (result) { return (__assign(__assign({}, emptyKeysObject), result)); });
};
